import { isEmpty } from 'es-toolkit/compat';
import isValid from 'date-fns/isValid';
import { format, parseISO } from 'date-fns';

type DateTimeFormatOptions = Intl.DateTimeFormatOptions;

export class DateTimeFormatter {
  private locale: string = Intl.DateTimeFormat().resolvedOptions().locale;

  private timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;

  private formatiertesDatumOptions: DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: this.timezone,
  };

  private formatiertesDatumMonatAusgeschriebenOptions: DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    timeZone: this.timezone,
  };

  private formatierteUhrzeitOptions: DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'UTC',
  };

  private formatiertesDatumMitUhrzeitOptions: DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: this.timezone,
  };

  private formatiertesDatumMitUhrzeitOhneSekundenOptions: DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: this.timezone,
  };

  formatiertesDatum(date?: string | Date): string {
    let dateToFormat: Date;

    if (date !== undefined && date instanceof Date) {
      dateToFormat = date;
    } else if (!isEmpty(date)) {
      dateToFormat = new Date(date);
    }

    if (dateToFormat === undefined) {
      return '';
    }

    return Intl.DateTimeFormat(this.locale, this.formatiertesDatumOptions).format(dateToFormat);
  }

  formatiertesDatumMonatAusgeschrieben(date?: string | Date): string {
    let dateToFormat: Date;

    if (date !== undefined && date instanceof Date) {
      dateToFormat = date;
    } else if (!isEmpty(date)) {
      dateToFormat = new Date(date);
    }

    if (dateToFormat === undefined) {
      return '';
    }

    return new Intl.DateTimeFormat(
      this.locale,
      this.formatiertesDatumMonatAusgeschriebenOptions,
    ).format(dateToFormat);
  }

  formatierteUhrzeit(time: number): string {
    const timeToFormat = new Date(time);
    return timeToFormat.toLocaleTimeString(this.locale, this.formatierteUhrzeitOptions);
  }

  formatiertesDatumMitUhrzeit(date: Date): string {
    const dateToFormat = new Date(date);
    if (!isValid(dateToFormat)) {
      return '';
    }
    return `${Intl.DateTimeFormat(this.locale, this.formatiertesDatumMitUhrzeitOptions).format(
      dateToFormat,
    )} Uhr`;
  }

  formatiertesLocalDateTime(input?: string): string {
    if (!input) {
      return '';
    }
    const date = parseISO(input);
    return format(date, "yyyy-MM-dd'T'HH:mm:ss");
  }

  formatiertesDatumMitUhrzeitOhneSekunden(date: Date): string {
    const dateToFormat = new Date(date);
    return `${Intl.DateTimeFormat(
      this.locale,
      this.formatiertesDatumMitUhrzeitOhneSekundenOptions,
    ).format(dateToFormat)} Uhr`;
  }

  formatDate(input?: string): string {
    if (!isEmpty(input)) {
      const date = parseISO(input);
      return isValid(date) ? format(date, 'yyyy-MM-dd') : null;
    }
  }
}
